import http from "./http";

export const getSupportDashboardData = (params = {}) =>
  http.get("/auth/dashboard/support/", { params });
